import { createSlice } from "@reduxjs/toolkit";
import { getCustomersData, getSellersData } from "../actions/chat";

const showBold = (isSeller, sellerId, customerId, conversationId, conversationContext) => {
  if (isSeller) {
    if (conversationContext === 'sellers' && conversationId === sellerId) {
      return false
    }
    return true
  }
  else {
    if (conversationContext === 'customers' && customerId === conversationId) return false;
    return true
  }
}


const getUpdatedList = (tempCustomers, message, sellerId, customerId, isSeller, isReceived = false, conversationId, conversationContext) => {
  const customerIndex = tempCustomers.findIndex(item => item.seller.id === sellerId && item.customer.id === customerId)

  tempCustomers[customerIndex] = {
    ...tempCustomers[customerIndex],
    message: message,
    position: isReceived ? isSeller ? 'right' : 'left' : isSeller ? 'left' : 'right',
    created_at: new Date().toISOString(),
    show_bold: showBold(isSeller, sellerId, customerId, conversationId, conversationContext)
  }

  const currentMessage = tempCustomers.splice(customerIndex, 1)[0]

  tempCustomers.splice(0, 0, currentMessage)

  return tempCustomers
}

const chatSlice = createSlice({
  name: "showChat",
  initialState: {
    showChat: false,
    sellersLoading: false,
    customersLoading: false,
    sellers: [],
    customers: [],
    customersUnreadCount: 0,
    sellersUnreadCount: 0
  },
  reducers: {
    toogleChat: (state, action) => {
      state.showChat = !state.showChat;
    },
    hideChat: (state) => {
      state.showChat = false;
    },
    updateChat(state, action) {
      const { message, sellerId, customerId, updateRequestedOn, isReceived = false, conversationId, conversationContext } = action.payload

      if (updateRequestedOn === 'customers') {
        const tempCustomers = [...state.customers]
        const updatedCustomers = getUpdatedList(tempCustomers, message, sellerId, customerId, false, isReceived, conversationId, conversationContext)
        state.customers = [...updatedCustomers]
        if (isReceived && showBold(false, sellerId, customerId, conversationId, conversationContext)) {
          state.customersUnreadCount++
        }
      }

      else if (updateRequestedOn === 'sellers') {
        const tempSellers = [...state.sellers]
        const updatedSellers = getUpdatedList(tempSellers, message, sellerId, customerId, true, isReceived, conversationId, conversationContext)
        state.sellers = [...updatedSellers]
        if (isReceived && showBold(true, sellerId, customerId, conversationId, conversationContext)) {
          state.sellersUnreadCount++
        }
      }
    },

    addSellerChat(state, action) {
      const sellerObject = action.payload
      const tempSellers = [...state.sellers]
      const sellerIndex = tempSellers.findIndex(item => item.seller.id === sellerObject.seller.id && item.customer.id === sellerObject.customer.id)
      if (sellerIndex !== -1) {
        getUpdatedList(tempSellers, sellerObject.message, sellerObject.seller.id, sellerObject.customer.id)
      } else {
        state.sellers.unshift(sellerObject)
      }
    },
    onChatPressed(state, action) {
      const { chatId, updateRequestedOn } = action.payload
      console.log('Chat Id', chatId)
      console.log('updateRequestedOn Id', updateRequestedOn)

      if (updateRequestedOn === 'customers') {
        state.customers.find(item => item.id === chatId).show_bold = false
        if (state.customersUnreadCount > 0) state.customersUnreadCount--
      } else {
        state.sellers.find(item => item.id === chatId).show_bold = false
        if (state.sellersUnreadCount > 0) state.sellersUnreadCount--
      }

    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomersData.pending, (state) => {
      state.customersLoading = true
    })

    builder.addCase(getCustomersData.fulfilled, (state, action) => {
      state.customersUnreadCount = action.payload.unseenCount
      state.customers = [...action.payload.data.data]
    })

    builder.addCase(getSellersData.pending, (state) => {
      state.sellersLoading = true
    })

    builder.addCase(getSellersData.fulfilled, (state, action) => {
      state.sellersUnreadCount = action.payload.unseenCount
      state.sellers = [...action.payload.data.data]
    })

  }
});



export const { toogleChat, hideChat, updateChat, addSellerChat, onChatPressed } = chatSlice.actions;
export default chatSlice.reducer;
